// @module LoginRegister View
define('SC.SummitThemeExtension.LoginRegister.Login.View', [
  'underscore',
  'SC.SummitThemeExtension.Common.Configuration',
  'SC.SummitThemeExtension.Common.LayoutHelper'
], function ThemeExtensionLoginRegister(_, Configuration, LayoutHelper) {
  'use strict';

  return {
    loadModule: function loadModule() {
      LayoutHelper.addToViewContextDefinition(
        'LoginRegister.Login.View',
        'extraLoginRegisterLoginView',
        'object',
        function () {
          return {
            loginSubtitle: Configuration.get('loginRegister.loginSubtitle'),
            loginText: Configuration.get('loginRegister.loginText')
          };
        }
      );
    }
  };
});
